import commodity from './commodity';
import containerGroup from './containerGroup';
import documentSet from './documentSet';
import entity from './entity';
import entityType from './entityType';
import event from './event';
import group from './group';
import harvestEvent from './harvestEvent';
import organization from './organization';
import person from './person';
import pickType from './pickType';
import quantityForecast from './quantityForecast';
import quantitySchedule from './quantitySchedule';
import scaffoldData from './scaffoldData';
import user from './user';
import variety from './variety';

const schemas = {
    commodity,
    commodities: [commodity],
    containerGroup,
    containerGroups: [containerGroup],
    documentSet,
    documentSets: [documentSet],
    entity,
    entities: [entity],
    entityType,
    entityTypes: [entityType],
    event,
    events: [event],
    group,
    groups: [group],
    harvestEvent,
    harvestEvents: [harvestEvent],
    organization,
    organizations: [organization],
    person,
    people: [person],
    pickType,
    pickTypes: [pickType],
    quantityForecast,
    quantityForecasts: [quantityForecast],
    quantitySchedule,
    quantitySchedules: [quantitySchedule],
    scaffoldData,
    user,
    users: [user],
    variety,
    varieties: [variety]
};

export default schemas;
